import router from '@/router'
import { isNil } from 'lodash'
import { createNewUserFromFirebaseAuthUser } from '@/misc/helpers'
import { database } from 'firebase';
// import UsersDB from '@/firebase/users-db'

export default {
  /**
   * Callback fired when user login
   */
  async login({ commit, dispatch }, firebaseUser) {
    let userRef = database().ref('users/' + firebaseUser.uid);
    let userSnap = await userRef.once('value');
    let user = userSnap.val();
    if (!user) {
      user = Object.assign({}, firebaseUser.toJSON(), {
        email: localStorage.getItem('emailForSignIn'),
        filter: {
          createdAt: Date.now(),
          installedAt: Date.now(),
          replacedAt: Date.now(),
          type: null
        }
      })
      await userRef.set(user)
    }

    commit('setUser', user)
  },
  async selectJug({ commit, state: { user } }, { type, replacedAt }) {
    let userRef = database().ref('users/' + user.uid);
    user = { ...user };
    user.filter = {
      createdAt: Date.now(),
      installedAt: replacedAt,
      replacedAt: replacedAt,
      type
    };
    await userRef.set(user)
    commit('setUser', user)
  },
  async resetJug({ commit, state: { user } }, dialog) {
    let userRef = database().ref('users/' + user.uid);
    user = { ...user };
    user.filter = {
      createdAt: Date.now(),
      installedAt: Date.now(),
      replacedAt: Date.now(),
      type: null
    };
    await userRef.set(user)
    commit('setUser', user)
  },
  /**
   * Callback fired when user logout
   */
  logout: ({ commit }) => {
    commit('setUser', null)
    // commit('products/setProducts', null, { root: true })

    const currentRouter = router.app.$route
    if (!(currentRouter.meta && currentRouter.meta.authNotRequired)) {
      router.push('/login')
    }
  }
}
